<template>
  <Modal
    :container-style="{
      width: '28rem',
      margin: '0 auto',
      backgroundColor: '#f3efea',
      // position: 'relative',
    }"
    @close="$emit('close')"
  >
    <div slot="body" class="report__body">
      <p class="disclaimer">
        Êtes-vous sûr de vouloir annuler le traitement de ce ticket ?<br>
        (cela annulera toutes les potentielles attributions de points et de remboursements)
      </p>
      <ul class="actions">
        <li class="action">
          <ButtonV3
            :loading="isCancelling"
            text="Annuler ce ticket"
            text-uppercase
            full-width
            color="white"
            :bg-color="paletteFidmarques.fuchsia"
            :border-color="paletteFidmarques.fuchsia"
            @click="$emit('confirmed')"
          />
        </li>
        <li class="action">
          <ButtonV3
            text="Ne pas annuler"
            text-uppercase
            full-width
            color="white"
            :bg-color="paletteFidmarques.yellow"
            :border-color="paletteFidmarques.yellow"
            @click="$emit('close')"
          />
        </li>
      </ul>
    </div>
  </Modal>
</template>

<script>
import Modal    from '../../elements/Modal'
import ButtonV3 from '../../elements/ButtonV3'
import MixinPaletteFidmarques from '~/mixins/paletteFidmarques'
export default {
  components: { Modal, ButtonV3 },
  mixins: [MixinPaletteFidmarques],
  props: {
    isCancelling: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.disclaimer {
  padding: 1rem;
}
.actions {
  list-style: none;
  padding: 1rem;
  margin: 0;
  text-align: center;
}
.action + .action {
  margin-top: 1rem;
}
</style>
